import React from 'react';
import DeprecationTracker from './DeprecationTracker';

export default function WebLinkDeprecationTracker() {
  return (
    <DeprecationTracker apiName="weblink" apiDisplayName="WebLink" />
  );
}
